// src/api/bookingApi.js
import api from "./api";

// ── USER ──────────────────────────────────────────────────
export const getServicesApi    = ()       => api.get("/bookings/services");
export const getAddressesApi   = ()       => api.get("/bookings/addresses");
export const addAddressApi     = (data)   => api.post("/bookings/addresses", data);
export const createBookingApi  = (data)   => api.post("/bookings/create", data);
export const verifyPaymentApi  = (data)   => api.post("/bookings/verify-payment", data);
export const createMultiBookingApi = (data) => api.post("/bookings/create-multi", data);
export const verifyMultiPaymentApi = (data) => api.post("/bookings/verify-payment-multi", data);
export const getMyBookingsApi  = ()       => api.get("/bookings/my-bookings");

// ── ADMIN ─────────────────────────────────────────────────
export const adminGetBookingsApi    = (params) => api.get("/bookings/admin/all", { params });
export const adminConfirmBookingApi = (id, data) => api.put(`/bookings/admin/${id}/confirm`, data);
export const adminUpdateStatusApi   = (id, data) => api.put(`/bookings/admin/${id}/status`, data);
export const adminAnalyticsApi      = ()          => api.get("/bookings/admin/analytics");
export const adminGetServicesApi    = ()          => api.get("/bookings/admin/services");
export const adminToggleServiceApi  = (id)        => api.put(`/bookings/admin/services/${id}/toggle`);
export const adminCreateServiceApi  = (data)      => api.post("/bookings/admin/services", data);
export const adminUpdateServiceApi  = (id, data)  => api.put(`/bookings/admin/services/${id}`, data);
export const submitFeedbackApi    = (bookingId, data) => api.post(`/bookings/${bookingId}/feedback`, data);
export const getMyFeedbackApi     = ()                => api.get("/bookings/my-feedback");
export const adminGetFeedbackApi  = (params)          => api.get("/bookings/admin/feedback", { params });